export class SettingsModel {
    public name: string;
    public value: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/settings.model.ts